var map = {
	"./en/image01.jpg": 462,
	"./es/image01.jpg": 1612
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2182;



/*****************
 ** WEBPACK FOOTER
 ** ./src/images/carousel ^\.\/.*\/image01\.jpg$
 ** module id = 2182
 ** module chunks = 0
 **/